import React from 'react'
import DepartmentCard from '../components/core/Courses/DepartmentCard'

const Courses = () => {
  return (
    <div>
        <DepartmentCard/>
    </div>
  )
}

export default Courses